import type {
    AnyObject,
    ApiResponseData,
} from '@frontend/types/AppTypes'
import type {CrmUserFile} from '@frontend/types/User'
import {ApiRequestService} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'

export type UploadMethod = 'form' | 'webrtc' | 'capture'

// API отправки файлов на сервер.
export const VayvndFileUploadingApi = {

    // Отправить Blob файл
    async uploadBlobFile(
        file: Blob,
        type: CrmUserFile['typeName'],
        uploadMethod: UploadMethod,
        fileName: string,
        exif?: AnyObject
    ): Promise<CrmUserFile> {
        const formData: FormData = new FormData()
        formData.append('type', type)
        formData.append('uploadMethod', uploadMethod)
        formData.append('file', file, fileName)
        formData.append('exif', exif ? JSON.stringify(exif) : '{}')
        return ApiRequestService
            .post<FileUploadResponseData>('/v1/client/file', formData)
            .then(response => response.data.file)
    },

}

interface FileUploadResponseData extends ApiResponseData {
    file: CrmUserFile
}

